import { MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router";
import AlertDialog from "../../components/alertDialog";
import ContextMenu from "../../components/contextMenu";
import useWybranaOrganizacja from "../../hooks/useWybranaOrganizacja";
import {
  OrganizacjaWidok,
  Produkt,
  RolaUzytkownika,
} from "../../store/types/organizacje";
import { OrganizacjaElementStyle } from "../../styles/OrganizacjaElementStyle";

interface OrganizacjaElementProps {
  element: OrganizacjaWidok;
  onEdit: () => void;
  onDelete: () => void;
  onOpusc: () => void;
}

const OrganizacjaElement = (props: OrganizacjaElementProps) => {
  const { element, onEdit, onDelete, onOpusc } = props;
  const [potwierdzUsuniecie, setPotwierdzUsuniecie] = useState(false);
  const [potwierdzOpuszczenie, setPotwierdzOpuszczenie] = useState(false);
  const { zmienWybrana, idWybranej } = useWybranaOrganizacja();
  const history = useHistory();

  function wybierz(o: OrganizacjaWidok) {
    zmienWybrana(o.Id);
    history.push(`/${o.Id}/organizacje`);
  }

  function dajRole(rola: RolaUzytkownika) {
    switch (rola) {
      case RolaUzytkownika.Wlasciciel:
        return "Właściciel";
      case RolaUzytkownika.Administrator:
        return "Administrator";
      case RolaUzytkownika.Uzytkownik:
        return "Użytkownik";
    }
  }

  function dajListeProduktow(produkty: Produkt[]) {
    var result: string[] = [];
    if (produkty.includes(Produkt.Brunet)) result.push("Brunet");
    if (produkty.includes(Produkt.Zioom)) result.push("Faktury");
    if (produkty.includes(Produkt.Ksef)) result.push("KSeF");
    return result.join(", ").toUpperCase();
  }

  return (
    <>
      <OrganizacjaElementStyle>
        <div className="kafel__tytul">
          <h4>{element.Nazwa}</h4>
          <ContextMenu>
            {element.Rola === RolaUzytkownika.Wlasciciel ? (
              <>
                <MenuItem onClick={onEdit}>Edytuj</MenuItem>
                <MenuItem onClick={() => setPotwierdzUsuniecie(true)}>
                  Usuń
                </MenuItem>
              </>
            ) : (
              <MenuItem onClick={() => setPotwierdzOpuszczenie(true)}>
                Opuść organizację
              </MenuItem>
            )}
          </ContextMenu>
        </div>
        <div className="kafel__opis">
          <span className="body1">{dajListeProduktow(element.Produkty)}</span>
          {element.Produkty.includes(Produkt.Brunet) && (
            <span className="body2">Księgowość dla Biur Rachunkowych</span>
          )}
          {element.Produkty.includes(Produkt.Zioom) && (
            <span className="body2">Fakturowanie dla Wszystkich</span>
          )}
          {element.Produkty.includes(Produkt.Ksef) && (
            <span className="body2">Krajowy system e-faktur</span>
          )}
        </div>
        <div className="kafel__stopka">
          <span className="body2">{dajRole(element.Rola)}</span>
          {idWybranej === element.Id ? (
            <span className="selected">WYBRANA</span>
          ) : (
            <button className="zmienbtn" onClick={() => wybierz(element)}>
              WYBIERZ
            </button>
          )}
        </div>
      </OrganizacjaElementStyle>
      {potwierdzUsuniecie && (
        <AlertDialog
          mode="YesNo"
          title="Potwierdzenie"
          content="Czy chcesz usunąć wybraną organizację?"
          onAccept={() => {
            setPotwierdzUsuniecie(false);
            onDelete();
          }}
          onCancel={() => setPotwierdzUsuniecie(false)}
        ></AlertDialog>
      )}
      {potwierdzOpuszczenie && (
        <AlertDialog
          mode="YesNo"
          title="Potwierdzenie"
          content="Czy chcesz opuścić wybraną organizację? Ta akcja jest nieodwracalna a ponowne przyłączenie będzie wymagało ponownego zaproszenia."
          onAccept={() => {
            setPotwierdzOpuszczenie(false);
            onOpusc();
          }}
          onCancel={() => setPotwierdzOpuszczenie(false)}
        ></AlertDialog>
      )}
    </>
  );
};

export default OrganizacjaElement;
